import React, { useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';
const LoadingChart = ({ show, height, size }) => {
   return (
      <div>
         {show && (
            <Box
               height={height || '400px'}
               style={{ backgroundColor: '#F2F2F2' }}
               borderRadius={'5px'}
               display={'flex'}
               justifyContent={'center'}
               alignItems={'center'}
            >
               <CircularProgress size={size || 20} />
            </Box>
         )}
      </div>
   );
};

export default LoadingChart;
